import router from "@/App/router/router";

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { version } from "../../../package.json";
import type { Vue } from "@sentry/vue/types/types";
import config from "@/App/config/main";

export const initSentry = (app: Vue): void => {
  if (!config.REPORT_CRASHES) {
    return;
  }
  Sentry.init({
    app,
    dsn: "https://cdf6f241e94242de97ddac9b0e5e708e@o39407.ingest.sentry.io/4504606263607296",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: [
          "dashboard-staging.twiagemed.net",
          "dashboard-demo.twiagemed.net",
          "dashboard.twiagemed.net",
          /^\//,
        ],
      }),
    ],
    tracesSampleRate: 1.0,
    release: version,
  });
};
